<template>
    <div class="review-list">
        <div v-for="(item, key) in items" :id="item.editAreaId" :key="key" class="review-list__item">
            <div class="r-review">
                <div class="r-review__top">
                    <div class="r-review__top-name">{{ item.NAME }}</div>
                    <div class="r-review__top-date">{{ item.ACTIVE_FROM }}</div>
                </div>
                <div class="r-review__text">
                    <p>{{ item.DETAIL_TEXT }}</p>
                </div>
                <div v-if="item.photo && item.photo.MIN && item.photo.MIN.src" class="r-review__photo" >
                    <img :src="item.photo.MIN.src" loading="lazy" />
                </div>
            </div>
            <div v-if="item.PROPERTIES.ADMIN_RESPONSE.VALUE" class="r-answer">
                <div class="r-answer__top">
                    <div class="r-answer__top-name">Администратор</div>
                    <div class="r-answer__top-date">{{ item.PROPERTIES.RESPONSE_DATE_UPDATE.VALUE }}</div>
                </div>
                <div class="r-answer__text">
                    <p>{{ item.PROPERTIES.ADMIN_RESPONSE.VALUE }}</p>
                </div>
            </div>
        </div>
        <div v-if="!all" @click="loadMore" class="review-btn btn">Загрузить еще</div>
    </div>
</template>

<script>
export default {
    name : "ProductReviewsList",
    props: {
        all_prop  : Boolean,
        items_prop: Array,
        product   : Number,
        limit     : Number
    },
    data() {
        return {
            offset: 2,
            items : [],
            all   : false,
        }
    },
    methods: {
        loadMore() {
            let formData = new FormData();
            formData.set('product', this.product.toString());
            formData.set('offset', this.offset.toString());
            formData.set('limit', this.limit.toString());
            fetch('/api/reviews/load_more/', {
                method: 'POST', body: formData
            })
                .then(response => response.json())
                .then(result => {
                    if(result.data.count <= this.offset * this.limit)
                        this.all = true;
                    if(result.data.reviews.length > 0)
                        for(let item in result.data.reviews)
                            this.items.push(result.data.reviews[item]);
                    this.offset++;
                })
        }
    },
    created() {
        this.all = this.all_prop;
        for(let item of this.items_prop)
            this.items.push(item);
    }
}
</script>

<style scoped>

</style>
